(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chat-widget"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('pn-chat');
    if (!root) return;

    var API_URL = root.getAttribute('data-api-url');
    var bubble = root.querySelector('.pn-chat__bubble');
    var panel = root.querySelector('.pn-chat__panel');
    var headerClose = root.querySelector('.pn-chat__header-close');
    var messagesEl = root.querySelector('.pn-chat__messages');
    var input = root.querySelector('.pn-chat__input');
    var sendBtn = root.querySelector('.pn-chat__send');

    var history = [];
    var isStreaming = false;
    var cartId = sessionStorage.getItem('pn-chat-cart') || null;

    function togglePanel() {
      var isOpen = root.classList.toggle('pn-chat--open');
      panel.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) input.focus();
    }

    bubble.addEventListener('click', togglePanel);
    headerClose.addEventListener('click', togglePanel);

    input.addEventListener('input', function () {
      sendBtn.disabled = !input.value.trim() || isStreaming;
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !sendBtn.disabled) {
        e.preventDefault();
        sendMessage();
      }
    });

    sendBtn.addEventListener('click', function () {
      if (!sendBtn.disabled) sendMessage();
    });

    function scrollToBottom() {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function renderBotText(text) {
      // Escape HTML entities first to prevent XSS
      var escaped = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

      return escaped
        // Bold: **text**
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        // Italic: *text* (not mid-word, no lookbehind for Safari compat)
        .replace(/(^|[\s(])\*([^*]+?)\*(?=[\s.,!?)]|$)/gm, '$1<em>$2</em>')
        // Links: [text](https://url)
        .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
        // Unordered list items: - item or * item
        .replace(/^[\-\*] (.+)$/gm, '<li>$1</li>')
        // Numbered list items: 1. item
        .replace(/^\d+\. (.+)$/gm, '<li>$1</li>')
        // Wrap consecutive <li> in <ul>
        .replace(/((?:<li>.*<\/li>\n?)+)/g, '<ul>$1</ul>')
        // Line breaks
        .replace(/\n/g, '<br>');
    }

    function addMessage(role, text) {
      var msgDiv = document.createElement('div');
      msgDiv.className = 'pn-chat__msg pn-chat__msg--' + role;
      var textDiv = document.createElement('div');
      textDiv.className = 'pn-chat__msg-text';
      if (role === 'bot') {
        textDiv.innerHTML = renderBotText(text);
      } else {
        textDiv.textContent = text;
      }
      msgDiv.appendChild(textDiv);
      messagesEl.appendChild(msgDiv);
      scrollToBottom();
      return textDiv;
    }

    function addTypingIndicator() {
      var msgDiv = document.createElement('div');
      msgDiv.className = 'pn-chat__msg pn-chat__msg--bot';
      msgDiv.id = 'pn-chat-typing';
      var typing = document.createElement('div');
      typing.className = 'pn-chat__typing';
      for (var i = 0; i < 3; i++) {
        var dot = document.createElement('div');
        dot.className = 'pn-chat__typing-dot';
        typing.appendChild(dot);
      }
      msgDiv.appendChild(typing);
      messagesEl.appendChild(msgDiv);
      scrollToBottom();
    }

    function removeTypingIndicator() {
      var el = document.getElementById('pn-chat-typing');
      if (el) el.remove();
    }

    function saveCartId(id) {
      if (id && id !== cartId) {
        cartId = id;
        sessionStorage.setItem('pn-chat-cart', id);
      }
    }

    async function sendMessage() {
      var text = input.value.trim();
      if (!text || isStreaming) return;

      isStreaming = true;
      input.value = '';
      sendBtn.disabled = true;

      addMessage('user', text);
      addTypingIndicator();

      try {
        var response = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: text, history: history, cartId: cartId }),
        });

        if (!response.ok) {
          removeTypingIndicator();
          var errBody = await response.json().catch(function () { return {}; });
          addMessage('bot', errBody.error || 'Sorry, something went wrong. Please try again.');
          isStreaming = false;
          return;
        }

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var botTextEl = null;
        var botText = '';
        var buffer = '';

        while (true) {
          var result = await reader.read();
          if (result.done) break;

          buffer += decoder.decode(result.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (!line.startsWith('data:')) continue;
            var jsonStr = line.slice(5).trim();
            if (!jsonStr) continue;

            try {
              var data = JSON.parse(jsonStr);
            } catch (e) {
              continue;
            }

            if (data.type === 'text') {
              if (!botTextEl) {
                removeTypingIndicator();
                botTextEl = addMessage('bot', '');
              }
              botText += data.content;
              botTextEl.innerHTML = renderBotText(botText);
              scrollToBottom();
            }

            if (data.type === 'cart_updated' && data.cartId) {
              saveCartId(data.cartId);
            }

            if (data.type === 'error') {
              removeTypingIndicator();
              if (!botTextEl) {
                addMessage('bot', data.content);
              }
            }

            if (data.type === 'done') {
              if (!botTextEl) {
                removeTypingIndicator();
                addMessage('bot', botText || 'Sorry, I could not generate a response.');
              }
            }
          }
        }

        history.push({ role: 'user', text: text });
        if (botText) {
          history.push({ role: 'assistant', text: botText });
        }

        if (history.length > 20) {
          history = history.slice(-20);
        }
      } catch (err) {
        removeTypingIndicator();
        addMessage('bot', 'Sorry, I could not connect. Please try again.');
      }

      isStreaming = false;
      sendBtn.disabled = !input.value.trim();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
